import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Redirect } from 'react-router-dom'
import InputMask from 'react-input-mask'

import './login.scss'

@observer
class Login extends Component {
    state = {
        login: '',
        loginErr: '',
        password: '',
    }

    refsArr = {
        getCode: null,
        setCode: null,
        authBtn: null,
    }

    chgInp = evt => {
        this.setState({
            [evt.target.name]: evt.target.value,
            loginErr: '',
        })
    }

    getCode = () => {
        if(this.state.login.length < 13){
            this.setState({
                loginErr: 'Некорректный номер телефона'
            })
        } else {
            const login = this.state.login
            const clearLogin = login.replace(/[^+\d]/g, '') // удалить все символы кроме плюса и цифр
            const phone = clearLogin.substr(1); // удаляем +
            this.props.getCode(phone)
        }        
    }

    tryAuth = () => {
        const login = this.state.login
        const clearLogin = login.replace(/[^+\d]/g, '') // удалить все символы кроме плюса и цифр
        // const phone = clearLogin.substr(1);

        this.props.tryAuth(clearLogin, this.state.password)
    }

    handleKeyPress = (event, nextFocus) => {
      if(event.key === 'Enter'){
        if(nextFocus){
            this.refsArr[nextFocus].focus()
        }
      }
    }

    render() {
        const { isLoggedIn, codeSended, codeSendedTime, errorMsg } = this.props
        if(isLoggedIn){
            return <Redirect to="/order" />
        }
        return (<>
            <div className="col-12 login-title">
                <h3>Авторизируйтесь, чтобы заказать авто онлайн</h3>
            </div>
            <div className="col-12">
                <div className="loginform-container">
                    <div className="row">
                        <div className="col-12">
                            <p className="login-label">Введите номер телефона</p>
                            <p className="login-sublabel">В международном формате +380001234578</p>
                            {codeSended && codeSendedTime > 0 ? <p className="resend-sms">Не получили код? Попробуйте повторить через {codeSendedTime} секунд</p> : null}
                            {this.state.loginErr.length > 0 || errorMsg.length > 0 ? <p className="login-error">{errorMsg.length > 0 ? errorMsg : this.state.loginErr}</p> : null}
                        </div>
                        <div className="col-8">
                            <InputMask mask="+380 (99) 999-99-99" type="text" name="login" maskChar={null} value={this.state.login} onChange={this.chgInp} onKeyPress={ evt => this.handleKeyPress(evt, 'getCode')} />
                        </div>
                        <div className="col-4 without-padding">
                            <button type="button" className="login-btn" onClick={this.getCode} disabled={codeSendedTime > 0 ? true : false } ref={ target => { this.refsArr.getCode = target }} onKeyPress={ evt => this.handleKeyPress(evt, 'setCode')} >Получить код</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p className="login-label">Введите код</p>
                        </div>
                        <div className="col-8">
                            <input type="password" name="password" value={this.state.password} maxLength="4" onChange={this.chgInp}  ref={ target => { this.refsArr.setCode = target }}  onKeyPress={ evt => this.handleKeyPress(evt, 'authBtn')} />
                        </div>
                        <div className="col-4 without-padding">
                            <button type="button" className="login-btn" onClick={this.tryAuth} disabled={codeSended || this.state.login.length === 19? false : true }  ref={ target => { this.refsArr.authBtn = target }}>Подтвердить</button>
                        </div>
                    </div>
                </div>
                <div className="side-car"></div>
            </div>
            </>
        )
    }
}

const withData = inject(stores => ({
    isLoggedIn: stores.LoginFromStore.isLoggedIn,
    codeSended: stores.LoginFromStore.codeSended,
    codeSendedTime: stores.LoginFromStore.codeSendedTime,
    tryAuth: stores.LoginFromStore.tryAuth,
    getCode: stores.LoginFromStore.getCode,
    errorMsg: stores.LoginFromStore.errorMsg,
}))

export default withData(Login);
